import Head from 'next/head'
import Image from 'next/image'

{/* importing components */}
import BlogPosts from '@/components/BlogPosts'
{/* finished importing components */}


export default function Home() {
  return (
    <>
      <Head>
        <title>Blog - Combat Warriors</title>
        <meta name="description" content="Read the latest blog posts from Combat Warriors. Stay up to date with the latest news, updates, and more!" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
        <meta name="theme-color" content="#000000" />
        <meta property="og:title" content="Combat Warriors" />
        <meta property="og:description" content="Read the latest blog posts from Combat Warriors. Stay up to date with the latest news, updates, and more!" />
        <meta property="og:image" content="https://assets.combatwarriors.gg/new_og_image.png" />
        <meta property="og:url" content="https://combatwarriors.gg" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Combat Warriors" />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>
      
      <main>
        <BlogPosts blogPage={true} />
      </main>
    </>
  )
}
